import React from 'react';

import * as S from './JobsPageTabs.style';

type JobsPageTabsProps = {
  tab: JobsPageTab;
  hasPublicJobs: boolean;
  hasRecentlyUsedJobs: boolean;
  hasProjectJobs: boolean;
  onTabChange: (_: any, newValue: JobsPageTab) => void;
};

export enum JobsPageTab {
  PROJECT = 'project',
  PUBLIC = 'public',
  RECENTLY_USED = 'recently used',
}

export const JOBS_PAGE_TAB_LABELS = {
  [JobsPageTab.PROJECT]: 'Project Jobs',
  [JobsPageTab.PUBLIC]: 'Public Jobs',
  [JobsPageTab.RECENTLY_USED]: 'Recently Used Jobs',
} as const;

export const JobsPageTabs = (props: JobsPageTabsProps) => {
  const {tab, onTabChange, hasPublicJobs, hasProjectJobs, hasRecentlyUsedJobs} =
    props;

  return (
    <S.JobTableTabs value={tab} onChange={onTabChange}>
      {hasProjectJobs && (
        <S.JobTableTab
          label={JOBS_PAGE_TAB_LABELS[JobsPageTab.PROJECT]}
          value={JobsPageTab.PROJECT}
        />
      )}
      {hasPublicJobs && (
        <S.JobTableTab
          label={JOBS_PAGE_TAB_LABELS[JobsPageTab.PUBLIC]}
          value={JobsPageTab.PUBLIC}
        />
      )}
      {hasRecentlyUsedJobs && (
        <S.JobTableTab
          label={JOBS_PAGE_TAB_LABELS[JobsPageTab.RECENTLY_USED]}
          value={JobsPageTab.RECENTLY_USED}
        />
      )}
    </S.JobTableTabs>
  );
};
